import { Box, Button, Stack, Typography } from '@mui/material';
import { m } from 'framer-motion';
import {
  type BarSegment,
  clampTickHeight,
  type NewSelection,
  type SelectedItem,
  SELECTED_COLOR,
  BAR_SEGMENT_ANIMATION_DURATION,
} from './constants';

type MonthLabelsProps = {
  monthBarSegments: BarSegment[];
  selectedItem: SelectedItem;
  setSelectedButton: (button: HTMLButtonElement) => void;
  setSelectedItem: (newSelection: NewSelection) => void;
};
export const MonthLabels = ({
  monthBarSegments,
  selectedItem,
  setSelectedButton,
  setSelectedItem,
}: MonthLabelsProps) => (
  <>
    {monthBarSegments.map(({ barBottom, barTop, value, numLessons }, index) => {
      const didSelectMonth = selectedItem.type === 'month' && selectedItem.data.value === value;
      return (
        <MonthLabel
          animate={{ delay: BAR_SEGMENT_ANIMATION_DURATION * index }}
          height={clampTickHeight(barBottom)}
          isSelected={didSelectMonth}
          key={value}
          monthName={value}
          onClick={() =>
            setSelectedItem({
              type: 'month',
              data: {
                height: (barBottom + barTop) / 2,
                numLessons: numLessons,
                value,
              },
            })
          }
          setSelectedButton={setSelectedButton}
        />
      );
    })}
  </>
);

type MonthLabelProps = {
  animate?: {
    delay: number;
  };
  height: number;
  isSelected: boolean;
  monthName: string;
  onClick: (month: string) => void;
  setSelectedButton: (button: HTMLButtonElement) => void;
};
const MonthLabel = ({
  animate,
  height,
  isSelected,
  monthName,
  onClick,
  setSelectedButton,
}: MonthLabelProps) => {
  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  } as const;
  return (
    <m.div
      animate="visible"
      initial="hidden"
      transition={{ duration: BAR_SEGMENT_ANIMATION_DURATION, delay: animate?.delay }}
      variants={variants}
    >
      <Button
        onClick={(e) => {
          onClick(monthName);
          setSelectedButton(e.currentTarget);
        }}
        sx={{
          borderRadius: '0 12px 12px 0',
          bottom: height,
          position: 'absolute',
          p: 0,
          left: '100%',
          transform: 'translateY(50%)',
          ':hover': {
            bgcolor: '#C1D2FC60',
          },
        }}
      >
        <Stack
          alignItems="center"
          bgcolor={isSelected ? '#FAEBF5' : undefined}
          borderRadius="0 12px 12px 0"
          direction="row"
          gap={0.5}
          p="8px 16px 8px 0"
        >
          <Box
            height={isSelected ? '2px' : '1px'}
            width="17px"
            bgcolor={isSelected ? SELECTED_COLOR : 'text.secondary'}
          />
          <Typography
            color={isSelected ? 'text.primary' : '#6C7589'}
            fontWeight={isSelected ? 700 : 600}
            fontSize={16}
          >
            {monthName}
          </Typography>
        </Stack>
      </Button>
    </m.div>
  );
};
